import React from "react";

export const UserContext = React.createContext({
    userProfile:{},
    updateUserProfile: ()=>{},
    themeToggle: ()=>{}
});

export function withUserProfile(Component){
    return function ProfileComponent(props){
        return (
            <UserContext.Consumer>
                { userProfile => <Component {...props} userData={userProfile} />}
            </UserContext.Consumer>
        )
    }
}